import { useTranslation } from 'react-i18next';

import { PASSWORD_MIN_LENGTH, PASSWORD_MAX_LENGTH } from 'constants/index';

import './PasswordErrors.styles.css';

type PasswordError = 'oneOf' | 'symbols' | 'match' | 'min' | 'max';

interface PasswordErrorsProps {
    value: PasswordError[]
}

const PasswordErrors = ({ value }: PasswordErrorsProps) => {
    const { t } = useTranslation('common')

    return (
        <div className="password-errors">
            {
                value.map(error => <p key={error}>{ t(`password.error.${error}`, { min: PASSWORD_MIN_LENGTH, max: PASSWORD_MAX_LENGTH }) }</p>)
            }
        </div>
    );
}

export default PasswordErrors;
